export var FrenchBillingErrorCode;
(function (FrenchBillingErrorCode) {
    FrenchBillingErrorCode["INVOICE_NUMBER_REQUIRED"] = "INVOICE_NUMBER_REQUIRED";
    FrenchBillingErrorCode["INVOICE_NUMBER_FORMAT_INVALID"] = "INVOICE_NUMBER_FORMAT_INVALID";
    FrenchBillingErrorCode["ISSUE_DATE_REQUIRED"] = "ISSUE_DATE_REQUIRED";
    FrenchBillingErrorCode["SERVICE_DATE_REQUIRED"] = "SERVICE_DATE_REQUIRED";
    FrenchBillingErrorCode["DUE_DATE_REQUIRED"] = "DUE_DATE_REQUIRED";
    FrenchBillingErrorCode["DUE_DATE_BEFORE_ISSUE_DATE"] = "DUE_DATE_BEFORE_ISSUE_DATE";
    FrenchBillingErrorCode["SERVICE_DATE_AFTER_ISSUE_DATE"] = "SERVICE_DATE_AFTER_ISSUE_DATE";
    FrenchBillingErrorCode["ISSUER_SIRET_REQUIRED"] = "ISSUER_SIRET_REQUIRED";
    FrenchBillingErrorCode["ISSUER_SIRET_FORMAT_INVALID"] = "ISSUER_SIRET_FORMAT_INVALID";
    FrenchBillingErrorCode["ISSUER_VAT_NUMBER_REQUIRED"] = "ISSUER_VAT_NUMBER_REQUIRED";
    FrenchBillingErrorCode["ISSUER_VAT_NUMBER_FORMAT_INVALID"] = "ISSUER_VAT_NUMBER_FORMAT_INVALID";
    FrenchBillingErrorCode["ISSUER_ADDRESS_REQUIRED"] = "ISSUER_ADDRESS_REQUIRED";
    FrenchBillingErrorCode["ISSUER_NAME_REQUIRED"] = "ISSUER_NAME_REQUIRED";
    FrenchBillingErrorCode["CLIENT_NAME_REQUIRED"] = "CLIENT_NAME_REQUIRED";
    FrenchBillingErrorCode["CLIENT_ADDRESS_REQUIRED"] = "CLIENT_ADDRESS_REQUIRED";
    FrenchBillingErrorCode["CLIENT_SIRET_REQUIRED"] = "CLIENT_SIRET_REQUIRED";
    FrenchBillingErrorCode["CLIENT_SIRET_FORMAT_INVALID"] = "CLIENT_SIRET_FORMAT_INVALID";
    FrenchBillingErrorCode["CLIENT_VAT_NUMBER_REQUIRED"] = "CLIENT_VAT_NUMBER_REQUIRED";
    FrenchBillingErrorCode["CLIENT_VAT_NUMBER_FORMAT_INVALID"] = "CLIENT_VAT_NUMBER_FORMAT_INVALID";
    FrenchBillingErrorCode["LINE_ITEMS_REQUIRED"] = "LINE_ITEMS_REQUIRED";
    FrenchBillingErrorCode["LINE_ITEM_DESIGNATION_REQUIRED"] = "LINE_ITEM_DESIGNATION_REQUIRED";
    FrenchBillingErrorCode["LINE_ITEM_QUANTITY_INVALID"] = "LINE_ITEM_QUANTITY_INVALID";
    FrenchBillingErrorCode["LINE_ITEM_UNIT_PRICE_INVALID"] = "LINE_ITEM_UNIT_PRICE_INVALID";
    FrenchBillingErrorCode["LINE_ITEM_VAT_RATE_REQUIRED"] = "LINE_ITEM_VAT_RATE_REQUIRED";
    FrenchBillingErrorCode["VAT_EXEMPTION_REASON_REQUIRED"] = "VAT_EXEMPTION_REASON_REQUIRED";
    FrenchBillingErrorCode["LEGAL_FOOTER_REQUIRED"] = "LEGAL_FOOTER_REQUIRED";
})(FrenchBillingErrorCode || (FrenchBillingErrorCode = {}));
